import * as tslib_1 from "tslib";
import { OnInit, TemplateRef } from '@angular/core';
import { TcErrorType } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-error';
import { DialogModel, LEVEL } from '@tc-core/model/it/codegen/ui/framework/dialog-model';
import { ConfigLoader } from '@tc-core/util/framework/config-loader.service';
import { SpinnerService } from '@tc-core/util/ui';
import { DialogService } from '@tc/dialog/dialog.service';
import { tap } from 'rxjs/operators';
import { TCO } from '../../../constants';
import { BrandSearchCriteria } from '../../../models/criteria/brand-search-criteria';
import { SortDirection } from '../../../models/helper/sort-direction';
import { MasterDataRestService } from '../../../services/backend-consumers/master-data-handler-service/master-data-rest.service';
import { BrandSetupService } from '../../../services/backend-consumers/setups/brand-setup-service';
import { CostingTypeService } from '../../../services/backend-consumers/setups/costing-type-service';
import { UserManagementService } from '../../../services/user-management/user-management.service';
import { DMCCommon } from '../../../services/util/common/dmc-common';
import { DataKey, DataStoreService } from '../../../services/util/framework/data-store.service';
import { SetupGridComp } from '../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid-comp';
import { SetupGridComponent } from '../../../widgets/framework/ag-grid-custom-components/components/setup-grid/setup-grid.component';
import { of, Subscription } from 'rxjs';
var BrandSetupComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BrandSetupComponent, _super);
    function BrandSetupComponent(configLoader, costingTypeService, dataStoreService, masterDataRestService, common, dataStore, brandSetupService, spinnerService, dialogService, userManagementService) {
        var _this = _super.call(this) || this;
        _this.configLoader = configLoader;
        _this.costingTypeService = costingTypeService;
        _this.dataStoreService = dataStoreService;
        _this.masterDataRestService = masterDataRestService;
        _this.common = common;
        _this.dataStore = dataStore;
        _this.brandSetupService = brandSetupService;
        _this.spinnerService = spinnerService;
        _this.dialogService = dialogService;
        _this.userManagementService = userManagementService;
        _this.colDefConfig = [];
        // search criteria obj. used to
        _this.brandSearchCriteria = new BrandSearchCriteria();
        _this.searchCriteriaObserver = new Subscription();
        _this.dialogSubscription = new Subscription();
        _this.allCostingTypeCodes = [];
        return _this;
    }
    BrandSetupComponent.prototype.ngOnInit = function () {
        this.colDefConfig = this.configLoader.configurations.get(TCO.CONF.CONF_BRAND_SETUP_CONFIG);
        this.subscribeSearchCriteria();
    };
    /**
     * subscribe search criteria changes in search bar
     * then force grid to refresh data
     * grid refresh will be call getRaws method which is using this subscribed criteria for backend call
     */
    BrandSetupComponent.prototype.subscribeSearchCriteria = function () {
        var _this = this;
        this.searchCriteriaObserver = this.dataStoreService.get(DataKey.brandSetupSearchCriteria).subscribe(function (value) {
            _this.brandSearchCriteria = value;
            _this.setupGrid.runForceSearch();
        });
    };
    BrandSetupComponent.prototype.createNewRow = function () {
        return { unsaved: true };
    };
    BrandSetupComponent.prototype.deleteRow = function (row) {
        return of('success');
    };
    BrandSetupComponent.prototype.getRows = function (params) {
        var _this = this;
        if (!this.brandSearchCriteria) {
            this.brandSearchCriteria = new BrandSearchCriteria();
        }
        this.brandSearchCriteria = this.userManagementService.updateSearchCriteriaWithUserKC(this.brandSearchCriteria);
        var pageSize = 14;
        if (params && params.endRow && params.startRow) {
            pageSize = params.endRow - params.startRow;
        }
        if (params && params.startRow) {
            this.brandSearchCriteria.start = params.startRow;
        }
        if (pageSize) {
            this.brandSearchCriteria.size = pageSize;
        }
        if (params.sortModel && params.sortModel[0]) {
            this.brandSearchCriteria.sortBy = params.sortModel[0].colId;
            if (params.sortModel[0].sort === SetupGridComp.GRID_SORT_ASCENDING) {
                this.brandSearchCriteria.sortDirection = SortDirection.ASC;
            }
            else {
                this.brandSearchCriteria.sortDirection = SortDirection.DESC;
            }
        }
        return this.brandSetupService.getRows(this.brandSearchCriteria)
            .pipe(tap(function (data) {
            _this.dataStoreService.set(DataKey.brandSetupSearchResultsForCriteria, data);
        }));
    };
    BrandSetupComponent.prototype.isInvalidRow = function (params) {
        var data = params.data;
        if (data) {
            var invalid = true;
            if (data.code &&
                data.name) {
                invalid = false;
            }
            return invalid;
        }
        else {
            return false;
        }
    };
    BrandSetupComponent.prototype.nonSelectionRow = function (params) {
        var data = params.data;
        if (data) {
            var invalid = true;
            if (data.code &&
                data.name) {
                invalid = false;
            }
            return invalid;
        }
        else {
            return false;
        }
    };
    BrandSetupComponent.prototype.isUnsavedRow = function (row) {
        if (row) {
            return !row.id;
        }
        return true;
    };
    BrandSetupComponent.prototype.isDisabledAdd = function () {
        var userProfile = this.dataStore.get(DataKey.userProfile).getValue();
        return (userProfile && userProfile.kcBrand);
    };
    BrandSetupComponent.prototype.saveRow = function (row, event) {
        var _this = this;
        if (row.unsaved) {
            var confirmSendManifests = new DialogModel(true, LEVEL.WARNING, 'Save Brand', 'The entered brand cannot be modified or deleted later. Do you want to continue?', true, 2000, null, 'Cancel', 'Save', true);
            confirmSendManifests.disableClose = true;
            if (this.dialogSubscription) {
                this.dialogSubscription.unsubscribe();
            }
            var dialogSubscription_1 = this.dialogService
                .confirm(confirmSendManifests)
                .subscribe(function (res) {
                if (res === true) {
                    return _this.brandSetupService.saveRow(row).subscribe(function (response) {
                        _this.userManagementService.getKcBrands();
                        _this.spinnerService.show();
                        dialogSubscription_1.unsubscribe();
                        _this.setupGrid.runForceSearch();
                        _this.spinnerService.hide();
                    }, function (error) {
                        _this.spinnerService.hide();
                        if (event && event.data) {
                            event.data.name = '';
                        }
                        _this.common.showSnackBar('Brand code cannot be duplicated', 3000, TcErrorType.TYPE.ERROR);
                    });
                }
                else {
                    if (event && event.data) {
                        event.data.name = '';
                    }
                }
            });
        }
        return null;
    };
    return BrandSetupComponent;
}(SetupGridComp));
export { BrandSetupComponent };
